module.exports = __webpack_public_path__ + "media/images/gallery/rn_tab_on-b23b0e87dd18dee37dbd9cbed0b6972f.jpg";